export default {
  data () {
    return {
      showLastEvents: false,
      service: undefined,
      fullHistory: []
    }
  },
  watch: {
    '$route' () {
      this.fullHistory = []
    }
  },
  computed: {
    eventEntity () {
      console.warn('You need to defined the eventEntity computed according to the current element')
      return []
    },
    events () {
      if (this.eventEntity) {
        return this.eventEntity.events
      } else {
        return []
      }
    },
    lastEvents () {
      return !!this.fullHistory && !!this.fullHistory.length ? this.fullHistory : this.events.slice(0, 5)
    },
    lastEvent () {
      if (this.events.length > 0) {
        return this.events[0]
      }
      return null
    }
  },
  methods: {
    getFullHistory () {
      this.service.getEvents(this.eventEntity.pk).then(r => {
        this.fullHistory = r.data
      })
    }
  },
  created () {
    if (!this.service) console.warn('need to define service')
  }
}



// WEBPACK FOOTER //
// ./src/mixins/EventTrackerMixin.js